import register from '@kpsys/angularjs-register';
import {KpMainMenuService} from 'shared/components/kp-main-menu/kp-main-menu.service';

export default register('portaro.shared.main-menu')
    .service(KpMainMenuService.serviceName, KpMainMenuService)
    .name();